import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';
import moment from 'moment';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { CompanyDTO, CompanyFilterDTO, CompanyPeopleFilterDTO, TestAgentDTO, TestAgentFilterDTO, ValueListDTO, ValueListFilterDTO, WorkspaceDTO } from '../../../shared/interfaces';
import { DatePickers, ISnackbarAlert, SelectField, SnackbarAlert, CardList, TextFieldInput, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { ListId, LocalStorange } from '../../../shared/environment';
import { WorkspaceFilterDTO } from '../../../shared/interfaces/testingSphere/WorkspaceFilterDTO';
import { TestAgentMaintenance } from './TestAgentMaintenance';

export const TestAgent: React.FC = () => {

    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [workspaceList, setWorkspaceList] = useState<WorkspaceDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);

    const [testAgentFilterDTO, setTestAgentFilterDTO] = useState<TestAgentFilterDTO>();
    const [testAgentList, setTestAgentList] = useState<TestAgentDTO[]>([]);

    const [actionExecuted, setActionExecuted] = useState(false);
    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setTestAgentFilterDTO({
            ...testAgentFilterDTO,
            name: '',
            workspaceId: '',
            companyId: ''
        } as TestAgentFilterDTO);

        handleWorkspaceGetAllAsync();
        handleCompanyGetAllAsync();
        handleListGetAll(ListId.testingsphere.testagent.status, setStatusList);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            handleTestAgentGetAllViewAsync();
        }, 15000);
        return () => clearInterval(interval);
    }, [testAgentFilterDTO]);

    useEffect(() => {
        handleTestAgentGetAllViewAsync();
    }, [testAgentFilterDTO]);

    useEffect(() => {
        if (actionExecuted)
            handleTestAgentGetAllViewAsync();
    }, [actionExecuted]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleWorkspaceGetAllAsync = useCallback(async () => {
        const workspaceFilterDTO: WorkspaceFilterDTO = {
            name: '',
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('testingSphere.workspace', workspaceFilterDTO, setLoading, setWorkspaceList, showMessage);
    }, []);

    const handleCompanyGetAllAsync = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpSphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleTestAgentGetAllViewAsync = useCallback(async () => {
        if (testAgentFilterDTO === undefined)
            return;

        GenericService.GetAllViewAsync1('testingSphere.testAgent', testAgentFilterDTO, setActionExecuted, setLoading, setTestAgentList, showMessage, true);

    }, [testAgentFilterDTO]);

    const handleClearFilterClick = () => {
        setTestAgentFilterDTO({ 
            ...testAgentFilterDTO, 
            name: '', 
            workspaceId: '', 
            companyId: '' });
    };

    function handleSearchClick() {
        handleTestAgentGetAllViewAsync();
    }

    const handleNew = () => {
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
    };

    const handleViewDetatils = (data: string) => {
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenance(true);
    };

    const handleDelete = (data: string) => {
        setNewRecord('');
        setDeleteRecord(data);
        setEditRecord('');
        setIsOpenMaintenance(true);
    };

    const toolBarActions: IDialogActions[] = [
        // { id: 'new', text: 'New TestAgent', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: testAgentList.length },
        { label: 'Workspace', value: workspaceList.find(x => x.id === testAgentFilterDTO?.workspaceId)?.name },
        { label: 'company', value: companyList.find(x => x.id === testAgentFilterDTO?.companyId)?.name },
        { label: 'Status', value: statusList.find(x => x.id === testAgentFilterDTO?.statusId)?.value },
        { label: 'TestAgent Name', value: testAgentFilterDTO?.name },
    ];

    const columns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'ipAddress', label: 'IP Address', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'workspace', label: 'Workspace', size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'company', label: 'Company', size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'status', label: 'Status', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false },
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }
    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='TESTAGENT'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='companyId'
                                label='Company'
                                value={testAgentFilterDTO?.companyId}
                                setValue={setTestAgentFilterDTO}
                                obj={testAgentFilterDTO}
                                valueList={companyList}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='workspaceId'
                                label='Workspace'
                                value={testAgentFilterDTO?.workspaceId}
                                setValue={setTestAgentFilterDTO}
                                obj={testAgentFilterDTO}
                                valueList={workspaceList}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='name'
                                label='Test Package name'
                                value={testAgentFilterDTO?.name}
                                setValue={setTestAgentFilterDTO}
                                obj={testAgentFilterDTO}
                                placeholder={'TestAgent Name'}
                                maxLength={36}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='statusId'
                                label='Status'
                                value={testAgentFilterDTO?.statusId}
                                setValue={setTestAgentFilterDTO}
                                obj={testAgentFilterDTO}
                                valueList={statusList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                <Box sx={{ display: 'flex', maxHeight: '79vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                    <CardList
                        columns={columns}
                        rows={testAgentList}
                        actions={cardActions}
                        cardSize={12}
                        hasChildren={false}
                        setRowExpanded={setExpandedData}
                    />
                </Box>
                {newRecord && (
                    <TestAgentMaintenance
                        data={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {editRecord && (
                    <TestAgentMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'testingsphere.testAgent'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                />)}
            </LayoutDashboard>
        </React.Fragment >
    );
};